// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-modal-popup',
    // #endregion
    // #region Properties
    props: {
        id: {
            type: String,
            required: true
        },
        size: {
            type: String,
            required: false,
            default: 'default'
        },
        closeOnKeyEsc: {
            type: Boolean,
            required: false,
            default: true
        },
        closeOnOutsideClick: {
            type: Boolean,
            required: false,
            default: true
        },
        closable: {
            type: Boolean,
            required: false,
            default: true
        },
        windowCallback: {
            type: Function,
            required: false,
            default: null
        },
    },
    data: () => ({
        visible: false
    }),
    computed: {
        modalClasses() {
            return {
                [`size-${this.size}`]: this.size
            };
        },
        identifierClass() {
            return `g-modal-popup--${this.id}`;
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.show();
    },
    mounted() {
        this.setFocusToModal();
    },
    // #endregion
    // #region Core
    methods: {
        setFocusToModal() {
            let tDialog = this.$refs.dialog;
            this.$nextTick(() => {
                tDialog.focus();
            });
        },
        show() {
            this.visible = true;
        },
        close(state) {
            //Close
            host.notification.closeModal(this.id);
            //Callback
            if (this.windowCallback) {
                if (utils.isObject(state)) {
                    this.windowCallback(state);
                }
                else {
                    this.windowCallback({
                        state: state ?? 0
                    });
                }
            }
        },
        closeModalOnClickOutside(domEvent) {
            //vars
            let tDialog = this.$refs.dialog;
            //Check
            if (!this.closeOnOutsideClick) {
                return;
            }
            if (utils.isNull(tDialog)) {
                return;
            }
            if (tDialog.contains(domEvent.target)) {
                return;
            }
            //Close
            this.close();
        },
        closeModalOnEscapeKey(event) {
            //Check
            if (!this.closeOnKeyEsc) {
                return;
            }
            if (event.target !== document.activeElement) {
                return;
            }
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.close();
            }
        }
    }
    // #endregion
});
// #endregion
